<template>
    <div class="custom-select" tabindex="-1"
         @click="toggleDropdown" @focusout="showDropdown = false">
        <div class="selected-option">
            <span>{{ selectedValue ? prepend + selectedValue : placeholder }}</span>
            <span class="arrow" :class="showDropdown ? 'flip' : ''">
                <img src="/images/icons/arrow-down.svg" alt="arrow">
            </span>
        </div>
        <ul class="options" :class="showDropdown ? 'options--show' : 'options--hide'">
            <li v-for="(option, index) in options" :key="index" @click="selectOption(option)">
                {{ option?.text ?? option }}
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'CustomSelect',
    props: {
        modelValue: String, // The selected value for v-model
        options: Array, // Array of available options
        placeholder: String, // Placeholder text when no option is selected
        prepend: String // Text to prepend to the selected value
    },
    data() {
        return {
            showDropdown: false,
            selectedValue: this.options[0]?.text
                ? this.options.find(option => option.text === this.modelValue)?.text
                : this.modelValue
        };
    },
    methods: {
        toggleDropdown() {
            this.showDropdown = !this.showDropdown;
        },
        selectOption(option) {
            if (option?.text) {
                this.selectedValue = option.text;
                this.$emit('update:modelValue', option.value);
            } else {
                this.selectedValue = option;
                this.$emit('update:modelValue', option);
            }
        }
    },
    watch: {
        modelValue() {
            this.selectedValue = this.options[0]?.text
                ? this.options.find(option => option.text === this.modelValue)?.text
                : this.modelValue;
        }
    }
};
</script>
